// extracted by mini-css-extract-plugin
export default {"rating":"sJ-z","numberOfStars":"tJ-z","count":"uJ-z","barGraphSpacing":"vJ-z","barGraph":"wJ-z"};